<template>
    <div>
        <div class="d-flex align-center mb-1">

            <v-btn
                color="secondary"
                text
                small
                rounded
                @click="showCreateDialog"
            >
                <v-icon class="mr-2">mdi-plus-circle-outline</v-icon>
                Nowa wiadomość
            </v-btn>

        </div>

        <v-divider></v-divider>

        <loading-message v-if="messageIndexing" message="Pobieranie wiadomości..." class="my-5"></loading-message>

        <v-simple-table v-else-if="messages.length">
            <template v-slot:default>
                <tbody>
                <tr
                    v-for="message in messages"
                    :key="message.MessageID"
                >
                    <td>
                        <v-icon v-if="message.Type === 1" color="error">mdi-alert</v-icon>
                        <v-icon v-else-if="message.Type === 2" color="warning">mdi-exclamation</v-icon>
                        <v-icon v-else color="info">mdi-information</v-icon>
                    </td>
                    <th class="text-no-wrap">
                        {{ message.Title }}
                    </th>
                    <td>{{ message.Content }}</td>
                    <td class="text-no-wrap">{{ message.ExpiresAt }}</td>
                    <td>
                        <v-chip v-if="message.IsActive" x-small color="success" class="my-1">Aktywna</v-chip>
                        <v-chip v-else x-small class="my-1">Wygasła</v-chip>
                    </td>
                    <td class="text-right">

                        <v-menu
                            bottom
                            left
                            :offset-y="true"
                            rounded
                        >
                            <template v-slot:activator="{ on, attrs }">
                                <v-btn
                                    small
                                    icon
                                    v-bind="attrs"
                                    v-on="on"
                                >
                                    <v-icon>mdi-dots-vertical</v-icon>
                                </v-btn>
                            </template>

                            <v-list dense>
                                <v-list-item>
                                    <v-list-item-title>
                                        <a @click="showEditDialog(message)"><v-icon small>mdi-folder-edit-outline</v-icon> Edytuj</a>
                                    </v-list-item-title>
                                </v-list-item>

                                <v-list-item>
                                    <v-list-item-title>
                                        <a @click="showDeleteDialog(message)"><v-icon small>mdi-delete-outline</v-icon> Usuń</a>
                                    </v-list-item-title>
                                </v-list-item>

                            </v-list>
                        </v-menu>

                    </td>
                </tr>
                </tbody>
            </template>
        </v-simple-table>

        <v-alert
            v-else
            class="mt-5"
            border="left"
            colored-border
            type="info"
            elevation="1"
        >Brak dodanych wiadomości</v-alert>

        <v-dialog
            v-model="messageCreateDialog"
            persistent
            width="500"
        >
            <v-card>
                <v-card-title class="headline grey lighten-2 mb-5">
                    Nowa wiadomość
                    <v-spacer></v-spacer>
                    <v-btn
                        icon
                        @click="hideCreateDialog"
                    >
                        <v-icon>mdi-close</v-icon>
                    </v-btn>
                </v-card-title>

                <v-card-text>
                    <v-select
                        v-model="messageForm.Type"
                        :items="types"
                        label="Typ wiadomości*"
                        :error="$store.getters.hasValidationError('Type')"
                        :error-messages="$store.getters.validationError('Type')"
                    ></v-select>
                    <v-text-field
                        v-model="messageForm.Title"
                        label="Temat wiadomości*"
                        maxlength="30"
                        :counter="30"
                        :error="$store.getters.hasValidationError('Title')"
                        :error-messages="$store.getters.validationError('Title')"
                    ></v-text-field>
                    <v-textarea
                        v-model="messageForm.Content"
                        label="Treść wiadomości*"
                        maxlength="1000"
                        :counter="1000"
                        :error="$store.getters.hasValidationError('Content')"
                        :error-messages="$store.getters.validationError('Content')"
                    ></v-textarea>
                    <v-menu
                        v-model="messageCreateDialogExpiresAtDatePicker"
                        :close-on-content-click="false"
                        :nudge-right="40"
                        transition="scale-transition"
                        offset-y
                        min-width="auto"
                    >
                        <template v-slot:activator="{ on, attrs }">
                            <v-text-field
                                v-model="messageForm.ExpiresAt"
                                label="Wiadomość wygasa dnia"
                                prepend-icon="mdi-calendar"
                                readonly
                                clearable
                                v-bind="attrs"
                                v-on="on"
                            ></v-text-field>
                        </template>
                        <v-date-picker
                            v-model="messageForm.ExpiresAt"
                            @input="messageCreateDialogExpiresAtDatePicker = false"
                        ></v-date-picker>
                    </v-menu>
                    <small>* pole wymagane</small>
                </v-card-text>

                <v-divider></v-divider>

                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn
                        rounded
                        color="success"
                        @click="messageStore"
                        :loading="messageStoring"
                    >DODAJ</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>

        <v-dialog
            v-model="messageEditDialog"
            persistent
            width="500"
        >
            <v-card v-if="messageToEdit">
                <v-card-title class="headline grey lighten-2 mb-5">
                    Wiadomość: {{messageToEditTitleShort}}
                    <v-spacer></v-spacer>
                    <v-btn
                        icon
                        @click="hideEditDialog"
                    >
                        <v-icon>mdi-close</v-icon>
                    </v-btn>
                </v-card-title>
                <v-card-text>
                    <v-select
                        v-model="messageForm.Type"
                        :items="types"
                        label="Typ wiadomości*"
                        :error="$store.getters.hasValidationError('Type')"
                        :error-messages="$store.getters.validationError('Type')"
                    ></v-select>
                    <v-text-field
                        v-model="messageForm.Title"
                        label="Temat wiadomości*"
                        maxlength="30"
                        :counter="30"
                        :error="$store.getters.hasValidationError('Title')"
                        :error-messages="$store.getters.validationError('Title')"
                    ></v-text-field>
                    <v-textarea
                        v-model="messageForm.Content"
                        label="Treść wiadomości*"
                        maxlength="1000"
                        :counter="1000"
                        :error="$store.getters.hasValidationError('Content')"
                        :error-messages="$store.getters.validationError('Content')"
                    ></v-textarea>
                    <v-menu
                        v-model="messageEditDialogExpiresAtDatePicker"
                        :close-on-content-click="false"
                        :nudge-right="40"
                        transition="scale-transition"
                        offset-y
                        min-width="auto"
                    >
                        <template v-slot:activator="{ on, attrs }">
                            <v-text-field
                                v-model="messageForm.ExpiresAt"
                                label="Wiadomość wygasa dnia"
                                prepend-icon="mdi-calendar"
                                readonly
                                clearable
                                v-bind="attrs"
                                v-on="on"
                            ></v-text-field>
                        </template>
                        <v-date-picker
                            v-model="messageForm.ExpiresAt"
                            @input="messageEditDialogExpiresAtDatePicker = false"
                        ></v-date-picker>
                    </v-menu>
                    <small>* pole wymagane</small>
                </v-card-text>

                <v-divider></v-divider>

                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn
                        rounded
                        color="success"
                        @click="messageUpdate"
                        :loading="messageUpdating"
                    >ZAPISZ</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>

        <v-dialog
            v-model="messageDeleteDialog"
            persistent
            width="500"
        >
            <v-card v-if="messageToDelete">
                <v-card-title class="headline grey lighten-2 mb-5">
                    Usuwanie wiadomości
                    <v-spacer></v-spacer>
                    <v-btn
                        icon
                        @click="hideDeleteDialog"
                    >
                        <v-icon>mdi-close</v-icon>
                    </v-btn>
                </v-card-title>

                <v-card-text>
                    Czy na pewno chcesz usunąć wiadomość
                    <strong>{{messageToDelete.Title}}</strong>?
                </v-card-text>

                <v-divider></v-divider>

                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn
                        color="error"
                        rounded
                        @click="messageDelete(messageToDelete)"
                        :loading="messageDeleting"
                    >Usuń</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </div>
</template>

<script>
import LoadingMessage from "../../../components/LoadingMessage";

export default {
    name: "Messages",

    components: {
        LoadingMessage,
    },

    data () {
        return {
            messageIndexing: false,
            messages: [],

            messageCreateDialog: false,
            messageCreateDialogExpiresAtDatePicker: false,
            messageStoring: false,

            messageEditDialog: null,
            messageEditDialogExpiresAtDatePicker: false,
            messageToEdit: null,
            messageUpdating: false,

            messageDeleteDialog: false,
            messageToDelete: null,
            messageDeleting: false,

            messageForm: {
                Type: null,
                Title: null,
                Content: null,
                ExpiresAt: null,
            },

            types: [
                {"value": 1, "text": "Bardzo ważna"},
                {"value": 2, "text": "Ważna"},
                {"value": 3, "text": "Zwykła"},
            ],
        };
    },

    computed: {
        messageToEditTitleShort() {
            if(!this.messageToEdit) {
                return null;
            }
            return this.messageToEdit.Title.length > 15
                ? this.messageToEdit.Title.substring(0, 15) + "..."
                : this.messageToEdit.Title;
        },
    },

    methods: {
        messageIndex: function () {
            this.messageIndexing = true;

            this.$store.dispatch('messageIndex')
                .then(response => {
                    if (response.status === 200) {
                        this.messages = response.data.data;
                    } else {
                        this.$store.commit("showSnackbarError", "Błąd wczytywania wiadomości.");
                    }
                })
                .catch(error => {})
                .then(() => {
                    this.messageIndexing = false;
                });
        },
        messageStore: function () {
            this.messageStoring = true;

            this.$store.dispatch('messageStore', this.messageForm).then(response => {
                if ([200, 201].includes(response.status)) {
                    this.hideCreateDialog();
                    this.$store.commit("showSnackbarSuccess", "Dodano wiadomość.");
                    this.messageIndex();
                } else {
                    this.$store.commit("showSnackbarError", "Błąd zapisu wiadomości.");
                }
            })
                .catch(error => {})
                .then(() => {
                    this.messageStoring = false;
                });
        },
        messageUpdate: function () {
            this.messageUpdating = true;

            this.$store.dispatch('messageUpdate', {
                MessageID: this.messageToEdit.MessageID,
                formData: this.messageForm
            }).then(response => {
                if ([200, 201].includes(response.status)) {
                    this.hideEditDialog();
                    this.$store.commit("showSnackbarSuccess", "Zapisano zmiany w wiadomości.");
                    this.messageIndex();
                } else {
                    this.$store.commit("showSnackbarError", "Błąd zapisu wiadomości.");
                }
            })
                .catch(error => {})
                .then(() => {
                    this.messageUpdating = false;
                });
        },
        messageDelete: function (message) {
            this.messageDeleting = true;

            this.$store.dispatch('messageDelete', message.MessageID).then(response => {
                if (response.status === 204) {
                    this.hideDeleteDialog();
                    this.$store.commit("showSnackbarSuccess", "Usunięto wiadomość.");
                    this.messageIndex();
                } else {
                    this.$store.commit("showSnackbarError", "Błąd usuwania wiadomości.");
                }
            })
                .catch(error => {})
                .then(() => {
                    this.messageDeleting = false;
                });
        },
        showCreateDialog: function () {
            this.messageCreateDialog = true;
        },
        hideCreateDialog: function () {
            this.messageCreateDialog = false;
            this.resetMessageForm();
            this.$store.commit("resetValidation");
        },
        showEditDialog: function (message) {
            this.messageToEdit = message;
        },
        hideEditDialog: function () {
            this.messageEditDialog = false;
        },
        showDeleteDialog: function (message) {
            this.messageToDelete = message;
        },
        hideDeleteDialog: function () {
            this.messageDeleteDialog = false;
        },
        resetMessageForm: function () {
            for (const index in this.messageForm) {
                this.messageForm[index] = null;
            }
        },
        setMessageForm: function (message) {
            this.messageForm.Type = message.Type;
            this.messageForm.Title = message.Title;
            this.messageForm.Content = message.Content;
            this.messageForm.ExpiresAt = message.ExpiresAt;
        },
    },
    created() {
        this.messageIndex();
    },
    watch: {
        messageToEdit: function (message) {
            if(message !== null) {
                this.setMessageForm(message);
                this.messageEditDialog = true;
            }
        },
        messageEditDialog: function (visible) {
            if(!visible) {
                this.resetMessageForm();
                this.$store.commit("resetValidation");
                this.messageToEdit = null;
            }
        },
        messageToDelete: function (message) {
            if(message !== null) {
                this.messageDeleteDialog = true;
            }
        },
        messageDeleteDialog: function (visible) {
            if(!visible) {
                this.messageToDelete = null;
            }
        },
    },
}
</script>

<style scoped>

</style>
